const indexAddStep = (index, length) => {
  if (index + 1 > length) return 0;
  else return index + 1;
}

export { indexAddStep }